import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UtlPerFinComponent } from './utl-per-fin.component';


const utlPerFinRoutes: Routes = [
  {
    path: '',
    component: UtlPerFinComponent,
    data: { title: 'Utilization, Personnel and Finances' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(utlPerFinRoutes)],
  exports: [RouterModule]
})
export class UtlPerFinRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/t8-utl-per-fin/utl-per-fin-routing.module.ts